module.exports = __webpack_public_path__ + "media/src/website/images/locations/altoetting/profile-1c0f40d9abda482fed0e5f421c8f65c3.jpg";